import { useEffect, useState } from 'react'

const useHeader = () => {
  const [timerVisible, setTimerVisible] = useState(
    localStorage.getItem('timerVisible') || 'off',
  )

  useEffect(() => {
    localStorage.setItem('timerVisible', timerVisible)
  }, [timerVisible])

  const handleVisibility = () => {
    timerVisible === 'on' ? setTimerVisible('off') : setTimerVisible('on')
  }

  return {
    timerVisible,
    handleVisibility,
  }
}

export default useHeader
